export default "__VITE_ASSET__Daym505x__"